<template>
<v-card>
  <v-card-title>
      <div>
        <h3 class="subheading" v-if="mediatype =='image'">Image message</h3>
        <h3 class="subheading" v-if="mediatype =='video'">Video message</h3>
        <h3 class="subheading" v-if="mediatype =='audio'">Audio message</h3>
        <h3 class="subheading" v-if="mediatype =='file'">File message</h3>
        <div class="caption grey--text">{{cMessage.name}}</div>
      </div>
      <v-spacer></v-spacer> 
          <v-btn icon @click="cancelCard"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-container grid-list-lg>
          <v-layout>
            <v-flex xs12 v-if="mediatype == 'audio' || mediatype == 'file'" > 
              <v-select                 
                  :items="afuploadtypes"
                  label="Upload from"
                  v-model="uploadtype"
              ></v-select>
            </v-flex>                       
            <v-flex xs6 v-if="mediatype == 'image' || mediatype == 'video'" >
              <v-select                 
                  :items="buttonoptions"
                  label="Required button?"
                  v-model="button"
              ></v-select>
            </v-flex>
            <v-flex xs6 v-if="(mediatype == 'image' || mediatype == 'video') && button == 'Yes'">
              <v-select                  
                  :items="byuploadtypes"
                  label="Upload from"
                  v-model="uploadtype"
              ></v-select>
              </v-flex>
              <v-flex xs6 v-if="(mediatype == 'image' || mediatype == 'video') && button == 'No'">
              <v-select                  
                  :items="bnuploadtypes"
                  label="Upload from"
                  v-model="uploadtype"
              ></v-select>
            </v-flex>
          </v-layout >  
              <v-text-field              
                v-if="uploadtype == 'URL'"
                label="URL"
                v-model="url"
                placeholder="Enter url here"
              ></v-text-field>
              <v-text-field              
                v-if="uploadtype == 'Facebook URL'"
                label="Facebook URL"
                v-model="url"
                placeholder="Enter facebook url here"
              ></v-text-field>
              <v-autocomplete              
                v-if="uploadtype == 'Asset' && mediatype == 'image'"
                item-text="nickname" 
                :items="cassestsimages"
                label="Select the asset"
                v-model="asset"                
                return-object
              ></v-autocomplete>
              <v-autocomplete              
                v-if="uploadtype == 'Asset' && mediatype == 'video'"
                item-text="nickname" 
                :items="cassestsvideos"
                label="Select the asset"
                v-model="asset"                
                return-object
              ></v-autocomplete>
              <v-autocomplete              
                v-if="uploadtype == 'Asset' && mediatype == 'audio'"
                item-text="nickname" 
                :items="cassestsaudios"
                label="Select the asset"
                v-model="asset"                
                return-object
              ></v-autocomplete>
              <v-autocomplete              
                v-if="uploadtype == 'Asset' && mediatype == 'file'"
                item-text="nickname" 
                :items="cassestsfiles"
                label="Select the asset"
                v-model="asset"                
                return-object
              ></v-autocomplete>
          <div v-if="button == 'Yes'">    
              <v-select                  
                  :items="buttontypes"
                  label="Button Type"
                  v-model="buttontype"
                  item-text="name"
                  item-value="code"
              ></v-select>
              <v-text-field
                v-if="buttontype != 'element_share'"                
                label="Button Title"
                counter="20"
                v-model="buttontitle"                
              ></v-text-field>
              <v-text-field
               v-if="buttontype == 'web_url'"               
                label="Button URL" 
                v-model="buttonurl"             
              ></v-text-field>
              <v-select
                v-if="buttontype == 'web_url'"                  
                  :items="webviewsizes"
                  label="Web view Size"
                  v-model="buttonwebview_height_ratio"
                  item-text="name"
                  item-value="code"
              ></v-select>
              <v-text-field
                v-if="buttontype == 'phone_number'"                
                label="Phone Number"
                placeholder="Like +918886108007" 
                 v-model="buttonpayloadph"             
              ></v-text-field>
              <v-select
                  v-if="buttontype == 'postback'"                  
                  label="link a response"
                  :items="cresponses"
                  v-model="buttonpayloadpb"
                  item-text="name"
                  return-object
              ></v-select>                                                                        
            </div>               
        </v-container>
        <v-card-actions class="ma-0">
            <v-spacer></v-spacer>                  
                <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
                <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
        </v-card-actions>  
    </v-card>
</template>

<script>
import store from '../store';
export default {
  props:['mediatype'],
  data(){
    return{
      uploadtype:null,
      afuploadtypes:['Asset','URL'],
      byuploadtypes:['Asset','Facebook URL'],
      bnuploadtypes:['Asset','URL'],
      buttonoptions:['Yes','No'],
      url:null,
      asset:null,
      button:'No',
      buttontype:null,
      buttonpayloadph:null,
      buttonpayloadpb:null,
      buttonwebview_height_ratio:null,
      buttonurl:null,
      buttontitle:null,
      buttontypes:[{"name":"Link a Response","code":"postback"},{"name":"Weblink","code":"web_url"},{"name":"Phone number","code":"phone_number"},{"name":"Share","code":"element_share"}],
      webviewsizes:[{"name":"Compact","code":"compact"},{"name":"Tall","code":"tall"},{"name":"Full","code":"full"}]

    }
  },
  methods:{
    saveCard(){
      let uploadtype1 = this.uploadtype,
      url1 = this.url,
      mediatype1 = this.mediatype,
      asset1 = this.asset,
      button1 = this.button,
      buttontype1 = this.buttontype,
      buttonpayloadph1 = this.buttonpayloadph,
      buttonpayloadpb1 = this.buttonpayloadpb,
      buttonwebview_height_ratio1 = this.buttonwebview_height_ratio,
      buttonurl1 = this.buttonurl,
      buttontitle1 = this.buttontitle
      console.log(asset1)
      let index = this.$store.state.bTemplateindex
      this.createbutton(function(createdbutton){
      if(mediatype1 == "image" || mediatype1 == "video")
      {
        if(button1 == 'Yes'){
            if (uploadtype1 == 'Asset'){
              let sendmessage = {
                    "attachment": {
                      "type": "template",
                      "payload": {
                        "template_type": "media",
                        "elements": [
                            {
                              "media_type": mediatype1,
                              "attachment_id": asset1.id,
                              "buttons": [createdbutton]
                            }
                        ]
                      }
                    }    
              }
              let message = {"message":sendmessage, "type": 'media',"uploadtype":"asset","name":asset1.nickname,"mediatype":mediatype1,"button":button1} 
              store.dispatch('acreatebcastTextMessage', {index,message}) 
              let status = false
              store.dispatch('abcastmenuStatusChange',status)
            }
            else{
              let sendmessage = {
                    "attachment": {
                      "type": "template",
                      "payload": {
                        "template_type": "media",
                        "elements": [
                            {
                              "media_type": mediatype1,
                              "url": url1,
                              "buttons": [createdbutton]
                            }
                        ]
                      }
                    }    
              }
            let message = {"message":sendmessage, "type":"media", "mediatype":mediatype1,"uploadtype":"url","button":button1}              
            store.dispatch('acreatebcastTextMessage', {index,message})
            let status = false
            store.dispatch('abcastmenuStatusChange',status)
            }
        }
        else{
              if (uploadtype1 == 'Asset'){
              let sendmessage = {
                                  "attachment":{
                                    "type": mediatype1, 
                                      "payload":{
                                          "attachment_id": asset1.id
                                        }
                                    }
                          }
              let message = {"message":sendmessage, "type": mediatype1,"uploadtype":"asset","name":asset1.nickname} 
              store.dispatch('acreatebcastTextMessage', {index,message})           
              let status = false
              store.dispatch('abcastmenuStatusChange',status)
            } 
            else{
            let sendmessage = {
                                  "attachment":{
                                    "type":mediatype1, 
                                      "payload":{
                                          "url": url1
                                        }
                                    }
                          }
            let message = {"message":sendmessage, "type":mediatype1,"uploadtype":"url"}              
            store.dispatch('acreatebcastTextMessage', {index,message})
            let status = false
            store.dispatch('abcastmenuStatusChange',status)
            }
        }
        
      }
      else{
        if (uploadtype1 == 'Asset'){
          let sendmessage = { "attachment":{
                                "type":mediatype1, 
                                  "payload":{
                                      "attachment_id": asset1.id
                                    }
                                }
                      }
          let message = {"message":sendmessage, "type":mediatype1,"uploadtype":"asset","name":asset1.nickname}            
          store.dispatch('acreatebcastTextMessage', {index,message})
          let status = false
          store.dispatch('abcastmenuStatusChange',status)
        }
        else{
         let sendmessage = {
                              "attachment":{
                                "type":mediatype1, 
                                  "payload":{
                                      "url": url1
                                    }
                                }
                      }
        let message = {"message":sendmessage, "type":mediatype1,"uploadtype":"url"} 
        store.dispatch('acreatebcastTextMessage', {index,message})
        let status = false
        store.dispatch('abcastmenuStatusChange',status)
        }
      }
      })
      cancelCard()
    },
    cancelCard(){
      let status = false
      this.uploadtype = null
      this.url = null,
      this.assest = null,
      this.button = 'No',
      this.buttontype = null,
      this.buttonpayloadph = null,
      this.buttonpayloadpb = null,
      this.buttonwebview_height_ratio = null,
      this.buttonurl = null,
      this.buttontitle = null,
      this.$store.dispatch('abcastmenuStatusChange',status)
    },
    createbutton(callback){
        if(this.button == 'Yes'){
            let button = null
            if (this.buttontype != null && this.buttontype == "web_url")
            {
              button = {"title":this.buttontitle,"type":this.buttontype,"url":this.buttonurl,"webview_height_ratio":this.buttonswebview_height_ratio}
            }
            else if(this.buttontype != null && this.buttontype == "phone_number")
            {
              button = {"title":this.buttontitle,"type":this.buttontype,"payload":this.buttonpayloadph}
            }
            else if(this.buttontype != null && this.buttontype == "element_share")
            {
              button = {"type":this.buttontype}
            }
            else if(this.buttontype != null && this.buttontype == "postback")
            {
              button = {"title":this.buttontitle,"type":this.buttontype,"payload":this.buttonpayloadpb.id}
            }
            callback(button)
        }
        else{
          let button = null
          callback(button)
        }     
      }
  },
  computed:{
    cassestsimages(){
          if(this.$store.state.assets != null){
            let assets = this.$store.state.assets
            let images =  assets.filter(function(asset) {
              return asset.type == "image"
            });
          return images
          }
          else{
            return []
          }
      },
    cassestsvideos(){
          if(this.$store.state.assets != null){
            let assets = this.$store.state.assets
            let images =  assets.filter(function(asset) {
              return asset.type == "video"
            });
          return images
          }
          else{
            return []
          }
      },
      cassestsaudios(){
          if(this.$store.state.assets != null){
            let assets = this.$store.state.assets
            let images =  assets.filter(function(asset) {
              return asset.type == "audio"
            });
          return images
          }
          else{
            return []
          }
      },
      cassestsfiles(){
          if(this.$store.state.assets != null){
            let assets = this.$store.state.assets
            let images =  assets.filter(function(asset) {
              return asset.type == "file"
            });
          return images
          }
          else{
            return []
          }
      },
      cresponses(){
          return this.$store.state.responses
      },
      cMessage(){
        if(this.$store.state.bTemplateindex != null){
          return this.$store.state.bTemplateNames[this.$store.state.bTemplateindex]  
        } 
      }   
  }
}
</script>
